import { render, staticRenderFns } from "./SidebarPengakhiran.vue?vue&type=template&id=01ecb826&"
import script from "./SidebarPengakhiran.vue?vue&type=script&lang=js&"
export * from "./SidebarPengakhiran.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPengakhiran.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports